<template>
  <div @click="selectReview(review)" > 
    <div class="card mb-2 hover-scale-up cursor-pointer" :style="{'background-color': getBgColor(review)}">
      
      <div class="card-body py-4 py-lg-0 sh-lg-10 review-card"
           :style="{'background-image': 'linear-gradient(to right, rgba(256, 256, 256, 0) 75px, '+getBgColor(review)+' 80px), url('+settings.backendMediaUrl+review.establishment.logo+')'}">
        <div class="row g-0 h-100 align-content-center" style="">
          <div class="col-12 col-lg-2 d-flex flex-column justify-content-center mb-2 mb-lg-0 order-1 order-lg-1">            
            <div class="text-muted text-small d-lg-none">Etablissement</div>
            <div style="text-align:left;padding-left:20px;padding-right:8px;">
              <span class="rounded-pill d-block me-4 py-2" style="color:black;font-weight:bold;">
                {{review.establishment.name}} 
              </span>
            </div>
          </div>

          <div class="col-12 col-lg-2 d-flex flex-column justify-content-center mb-2 mb-lg-0 order-1 order-lg-1">            
            <div class="text-muted text-small d-lg-none">Status</div>
            <div>
                <span class="badge rounded-pill d-block me-4 py-2"
                      style="overflow:hidden;text-overflow:ellipsis;"
                      :title="getStatusLabel(review.current_state)"
                      :class="{
                        'bg-outline-warning': review.current_state && review.current_state.class_name=='WaitingForInformation',
                        'bg-outline-dark': review.current_state && (review.current_state.class_name=='AnswerWriting' || review.current_state.class_name=='AnswerTextValidation'),
                        'bg-outline-secondary': review.current_state && (review.current_state.class_name=='SignalingWriting' || review.current_state.class_name=='SignalingSent'),
                        'bg-outline-success': is_done(review)
                    }">
                {{ getStatusLabel(review.current_state) }}
                </span>
            </div>
          </div>
          
          <div class="col-6 col-lg-1 d-flex flex-column justify-content-center mb-2 mb-lg-0 order-4 order-lg-2">
            <div class="text-muted text-small d-lg-none">Nouveau<br>message</div>
            <div>
              <span class="badge rounded-pill bg-primary">{{review.nb_message}}</span>
            </div>
          </div>
          
          <div class="col-6 col-lg-1 d-flex flex-column justify-content-center mb-2 mb-lg-0 order-4 order-lg-2">
            <div class="text-muted text-small d-lg-none">Note</div>
            <div class="text-primary cta-2">{{review.mark}}<small>/10</small></div>
          </div>

          
          <div class="col-12 col-lg-3 d-flex flex-column justify-content-center mb-2 mb-lg-0 order-2 order-lg-3">
            <div class="text-muted text-small d-lg-none">Avis</div>
            <div class="name">{{review.author}}</div>
            <div class="text-alternate" style="padding-right:5px;overflow:hidden;display: -webkit-box;  -webkit-line-clamp: 2;-webkit-box-orient: vertical;">{{title}}</div>
          </div>
          <div class="col-6 col-lg-2 d-flex flex-column justify-content-center mb-2 mb-lg-0 order-3 order-lg-4">
            <div class="text-muted text-small d-lg-none">Date de notification</div>
            <div class="text-alternate">{{review.published_on|human_date}}</div>
          </div>
          
          <div class="col-6 col-lg-1 d-flex flex-column justify-content-center mb-2 mb-lg-0 order-last  order-lg-5 h-lg-100 position-relative">
            <div class="text-muted text-small d-lg-none">Plateforme</div>
            
            <img class="img-fluid rounded mb-1 me-1 sw-6" :alt="review.platform.name" :src="settings.backendMediaUrl+review.platform.logo2">
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import settings from '@/settings.coffee';

export default {
  name: 'EstablignmentGatheringLine',
  components: {},
  props: {
    review: Object
  },
  data() {
    return {
      settings
    };
  },
  computed: {
    title() {
      let ret = "";
      if (this.review && this.review.title_fr && this.review.title_fr !== "") {
        ret = this.review.title_fr.substring(0, 90);
      } else if (this.review && this.review.title_native && this.review.title_native !== "") {
        ret = this.review.title_native.substring(0, 90);
      } else if (this.review && this.review.text_fr && this.review.text_fr !== "") {
        ret = this.review.text_fr.substring(0, 90);
      } else if (this.review && this.review.text_native && this.review.text_native !== "") {
        ret = this.review.text_native.substring(0, 90);
      }
      return ret;
    }
  },
  methods: {
    getStatusLabel(state) {
      if (!state) return 'Traité';
      const labels = {
        'InformationNeeded': 'Information demandée',
        'WaitingForInformation': 'En attente d\'information',
        'AnswerWriting': 'Réponse à valider',
        'AnswerTextValidation': 'En cours validation',
        'SignalingWriting': 'En cours signalement',
        'SignalingSent': 'Signalement envoyé',
        'AnswerAccepted': 'Réponse acceptée',
        'AnswerPublished': 'Publié',
        'Classified': 'Traité',
      };
      return labels[state.class_name] || state.verbose_name || state.class_name;
    },
    is_done(review) {
      if (!review) return false
      if (!review.current_state) return true
      return (
        review.current_state.class_name === 'Classified' ||
        review.current_state.class_name === 'AnswerAccepted' ||
        review.current_state.class_name === 'AnswerPublished'
      )
    },
    getBgColor(review) {
      let ret = "#FFFFFF";
      if (this.is_done(review)) {
        ret = "rgb(237, 242, 235)";
      }
      return ret;
    },
    selectReview(review) {
      window.dispatchEvent(new CustomEvent('click_gathering_review_detail', { detail: review }));
    }
  },
  mounted() {
    // rien à faire
  }
};
</script>

<style>
  .review-card{
      background-size:contain;
      background-repeat:no-repeat;
      padding-left:80px !important;
  }
  
  @media (max-width: 991px){
      .review-card{
          background-size:unset;
          background-repeat:no-repeat;
          padding-left:1.5rem !important;
          padding-right:1.5rem !important;
          background-image: unset !important;
      }
      html[data-placement="horizontal"][data-mobile="true"] .nav-container .menu > li > a {
          display: flex !important;
      }
  }
</style>
